import { Role, TeamPermissionEnum } from '@data/sdk/match';
import { useAppUserStore } from '@data/storage';

export const getUserTeamPermissions = () => {
  const { user } = useAppUserStore.getState();
  const isTrialManager = user?.currentRole === Role.TrialManager;
  const isSponsor = user?.currentRole === Role.Sponsor;
  const isAdmin = user?.currentRole === Role.Admin;
  const isReviewer = user?.currentRole === Role.Reviewer;
  const isPatientOrg = user?.currentRole === Role.PatientOrg;
  const isPatient = user?.currentRole === Role.Volunteer;

  const teamPermissions = user?.teamPermissions;

  const TEAM_READ = isAdmin || teamPermissions?.includes(TeamPermissionEnum.TeamRead);
  const TEAM_WRITE = isAdmin || teamPermissions?.includes(TeamPermissionEnum.TeamWrite);
  const TEAM_USERS = isAdmin || teamPermissions?.includes(TeamPermissionEnum.TeamUsers);
  const TEAM_BILLING = isAdmin || teamPermissions?.includes(TeamPermissionEnum.TeamBilling);

  return {
    IS_TRIAL_MANAGER: isTrialManager,
    IS_SPONSOR: isSponsor,
    IS_ADMIN: isAdmin,
    IS_PATIENT: isPatient,
    IS_REVIEWER: isReviewer,
    IS_PATIENT_ORG: isPatientOrg,
    TEAM_PERMISSIONS: teamPermissions,
    TEAM_READ,
    TEAM_WRITE,
    TEAM_USERS,
    TEAM_BILLING,
  };
};
